function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import requiredImage from '../fragments/requiredImage.js';
import link from './link.js';
var schema = defineObject('logoCarouselSectionCard', {
    logo: _object_spread({
        title: 'Logo'
    }, requiredImage.fragment),
    title: {
        title: 'Title',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    label: {
        title: 'Label',
        type: 'string'
    },
    action: {
        title: 'Action',
        type: 'link'
    }
}, [
    link.schema.link
]);
var validator = z.object({
    logo: requiredImage.validator,
    title: z.string(),
    label: z.string(),
    action: link.validator
}).partial();
schema.logoCarouselSectionCard;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=logoCardsGridSectionCard.js.map